import React, { Component } from "react";
import Translator from "../../requests/apa/Translator";
import Asset from "../../requests/apa/Asset";
import store from "../../store";
import settings from "../../devices/all/settings";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import {GA4} from '../../utils/trackers/GA4';
import Utils from "../../utils/Utils";
import { VINCULARCORREO, VERPLANES, SELECTCONTENT, INICIO, MODULENAME } from "./constants";
import Device from "../../devices/device";

class Notification extends Component{
    constructor(props){
        super(props);
        this.firstButtonRef = null;
        this.secondButtonRef = null;
        this.keys = Device.getDevice().getKeys();
    }

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown, true);
        
        this.focusFirstButton();
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown, true);
        this.focusHomeNode();
    }

    handleKeyDown = (e) => {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        const activeElement = document.activeElement;
        
        // Verificar que el foco esté en uno de nuestros botones
        const isOnFirstButton = activeElement === this.firstButtonRef;
        const isOnSecondButton = activeElement === this.secondButtonRef;
        
        if (!isOnFirstButton && !isOnSecondButton) return;

        const hasTwoButtons = this.firstButtonRef && this.secondButtonRef && this.firstButtonRef !== this.secondButtonRef;

        if (currentKey === 'DOWN') {
            // Si está en el primer botón y hay un segundo botón, navegar internamente
            if (isOnFirstButton && hasTwoButtons) {
                e.preventDefault();
                e.stopPropagation();
                this.secondButtonRef.focus();
            } else if (this.props.isNavigationBlocked) {
                // Si el timer está activo, bloquear la salida del componente
                e.preventDefault();
                e.stopPropagation();
            }
            // Si el timer expiró y está en el último botón, permitir que el foco salga
        } else if (currentKey === 'UP') {
            // Si está en el segundo botón y hay un primer botón, navegar internamente
            if (isOnSecondButton && hasTwoButtons) {
                e.preventDefault();
                e.stopPropagation();
                this.firstButtonRef.focus();
            } else if (this.props.isNavigationBlocked) {
                // Si el timer está activo, bloquear la salida del componente
                e.preventDefault();
                e.stopPropagation();
            }
            // Si el timer expiró y está en el primer botón, permitir que el foco salga
        } else if (currentKey === 'LEFT' || currentKey === 'RIGHT') {
            // Bloquear navegación horizontal solo durante el tiempo configurado
            if (this.props.isNavigationBlocked) {
                e.preventDefault();
                e.stopPropagation();
            }
        }
    }

    // Poner foco en el prinmer botón cuando se abre
    focusFirstButton() {
        setTimeout(() => {
            if (!this.props.validEmail && this.firstButtonRef) {
                this.firstButtonRef.focus();
            } else if (this.secondButtonRef) {
                this.secondButtonRef.focus();
            }
        }, 100);
    }

    // Poner foco en el nodo inicio cuando se cierra
    focusHomeNode() {
        setTimeout(() => {
            const homeNode = document.getElementById('menu-homeuser') || 
                           document.querySelector('#aaf_menu-container-center .menu-item') ||
                           document.querySelector('.aaf_menu-button:first-child a');
            
            if (homeNode) {
                homeNode.focus();
            }
        }, 100);
    }

    goToSubscriptionPlans = () => {
        // Desactivar overlay y bloqueo antes de navegar
        if (this.props.deactivateOverlayAndBlocking) {
            this.props.deactivateOverlayAndBlocking();
        }
        
        this.sendMetrics(VERPLANES, MODULENAME);
        this.props.history.push(`/${settings.path_suscription}`)
    }

    goToRegisterEmail = () => {
        // Desactivar overlay y bloqueo antes de navegar
        if (this.props.deactivateOverlayAndBlocking) {
            this.props.deactivateOverlayAndBlocking();
        }
        
        this.sendMetrics(VINCULARCORREO, MODULENAME);
        const { user: { firstname = '', lastname = '' }, user } = store.getState();
        const ipTelmexData = { ipTelmexData: { isTelmex: true, firstname, lastname } };
        this.props.history.push(`/${settings.path_register}`, ipTelmexData);
    }

    sendMetrics(interaction_type, moduleName){
        const gA4 = new GA4();
        const event = SELECTCONTENT;
        const content_section = INICIO;
        const dataMetrics = Utils.getDataOnboardingIpTelmex(this.props.history, interaction_type, moduleName, event, content_section );
        gA4.sendMetricsOnboardingIPTelmex(dataMetrics);
    }

    render(){
        const { validEmail } = this.props;
        
        return(
            <div className='notification-container'>
                <div className='notification-content'>
                   <p>
                        {Translator.get('Onboarding2_CDN_NotificacionB_Texto_Parrafo1_Parte1')} 
                        <img src={Asset.get('Onboarding2_CDN_Notificacion_Logo')} alt="Telmex" /> 
                        {Translator.get('Onboarding2_CDN_NotificacionB_Texto_Parrafo1_Parte2')}&nbsp;
                        <span>{Translator.get('Onboarding2_CDN_NotificacionB_Texto_Parrafo1_Parte3')}</span>
                    </p>
                    <p>
                        {Translator.get('Onboarding2_CDN_NotificacionB_Texto_Parrafo2_Parte1')}&nbsp;
                        <span>{Translator.get('Onboarding2_CDN_NotificacionB_Texto_Parrafo2_Parte2')}</span>
                    </p>
                </div>
                <div className="notification-buttons-container">
                    {
                        !validEmail && <button 
                            className="notification-button focusable"
                            ref={(ref) => this.firstButtonRef = ref}
                            onClick={this.goToRegisterEmail}
                        >
                            {Translator.get('Onboarding2_CDN_Boton_Texto_VincularCorreo')}
                        </button>
                    }
                      <button 
                        className="notification-button focusable"
                        ref={(ref) => {
                            this.secondButtonRef = ref;
                            // Si no hay primer botón (validEmail es true, ya que el usuario ya cuenta con un correo válido), este sería el primer botón
                            if (validEmail) {
                                this.firstButtonRef = ref;
                            }
                        }}
                        onClick={this.goToSubscriptionPlans}
                      >
                        {Translator.get('Onboarding2_CDN_Boton_Texto_VerPlanes')}
                    </button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    validEmail: state.user.validEmail
});

export default withRouter(connect(mapStateToProps)(Notification));


// WEBPACK FOOTER //
// ./src/components/centerNotification/Notification.jsx